import { NativeDateAdapter } from '@angular/material/core';


export class CustomDateAdapter extends NativeDateAdapter{
  
  getFirstDayOfWeek(): number {
   return 1;
  }

}